import { FC } from 'react';

import { SvgIconProps } from '@mui/material';

export const UploadIcon: FC<SvgIconProps> = (props) => (
  <svg
    width="54"
    height="43"
    viewBox="0 0 54 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.1138 41.0771V23.6113"
      stroke="#98A2B3"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.8904 29.3034L27.1137 23.6113L32.3365 29.3034"
      stroke="#98A2B3"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.7517 33.446H43.6959C48.4068 33.446 52.2255 29.63 52.2255 24.9224C52.2255 20.2149 48.4605 16.4553 43.7959 16.4015C43.9411 15.7986 44.0202 15.1704 44.0202 14.5228C44.0202 10.1065 40.4376 6.52698 36.0187 6.52698C34.5603 6.52698 33.1938 6.91874 32.0166 7.60015C30.2162 4.26618 26.6895 2 22.632 2C16.7467 2 11.9756 6.76773 11.9756 12.6489C11.9756 13.0111 11.9939 13.3696 12.0294 13.7226C11.9767 13.7216 11.924 13.7189 11.8707 13.7189C6.41938 13.7189 2 18.1352 2 23.5827C2 29.0302 6.41938 33.4465 11.8707 33.4465C11.9057 33.4465 11.9401 33.4444 11.9751 33.4438V33.4465H17.5356"
      stroke="#98A2B3"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
